import { update } from 'lodash';
import actionTypes from './../constants/actionTypes';

const initialState = {
    instruments: {},
    holdings: {},
    trades: {},
    updateTrade: {},
    executeTrade: {},
    holdingsChartData: {},
    trackTradeListing: {},
};

export const zerodhaReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.ZERODHA.LIST_HOLDINGS: {
                return {
                    ...state,
                    holdings: payload
                }
            }
            case actionTypes.ZERODHA.LIST_INSTRUMENTS: {
                return {
                    ...state,
                    instruments: payload
                }
            }
            case actionTypes.ZERODHA.LIST_TRADES: {
                return {
                    ...state,
                    trades: payload
                }
            }
            case actionTypes.ZERODHA.UPDATE_TRADE: {
                return {
                    ...state,
                    updateTrade: payload
                }
            }
            case actionTypes.ZERODHA.EXECUTE_TRADE: {
                return {
                    ...state,
                    executeTrade: payload
                }
            }
            case actionTypes.ZERODHA.HOLDINGS_CHART_DATA: {
                return {
                    ...state,
                    holdingsChartData: payload
                }
            }
            case actionTypes.ZERODHA.TRACK_TRADE_LISTING: {
                return {
                    ...state,
                    trackTradeListing: payload
                }
            }
            default: return state;
        }
    } catch (error) {
        return state;
    }
}
export default zerodhaReducer;
